import React from 'react';
import { Input, Button, CheckboxTable, Select, PaperClip, Textarea } from 'components';
import { ChatService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants, checkPermission } from 'utils';

interface Props {
	onClose?: any;
	item?: any;
}

class ModalCreate extends React.Component<Props> {

	state = {
		form: {
			content: ''
		}
	}

	componentDidMount() {
		if (this.props.item) {
			this.setState({
				form: {
					...this.state.form,
					content: this.props.item?.content || ''
				}
			});
		}
	}

	submit = async (e: any) => {
		e.preventDefault();
		await ChatService.admin.saveInformation({
			content_id: this.props.item?.id,
			...this.state.form
		});
		Globals.showSuccess("Se ha guardado la información correctamente");
		this.props.onClose();
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}
	
	render() {
		return (
			<div id="modal-create-information">
				<form className="row" onSubmit={ this.submit }>
					<div className="col-md-12">
						<Textarea
							rows={ 18 }
							color="white"
							value={ this.state.form.content }
							name="content" 
							placeholder="Contenido"
							onChange={ this.change } />
					</div>
					<div className="col-md-12 text-center">
						<Button className="btn-submit" type="submit">
							Guardar
						</Button>
					</div>
				</form>
			</div>
		)
	}
}

export default ModalCreate;